export var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["PENDING"] = "PENDING";
    EnrollmentStatus["ACTIVE"] = "ACTIVE";
    EnrollmentStatus["PAUSED"] = "PAUSED";
    EnrollmentStatus["CANCELED"] = "CANCELED";
    EnrollmentStatus["COMPLETED"] = "COMPLETED";
    EnrollmentStatus["EXPIRED"] = "EXPIRED";
})(EnrollmentStatus || (EnrollmentStatus = {}));
/**
 * Non-terminal enrollment statuses — the single source of truth for which
 * enrollments are considered "countable"/active-ish across backend queries and
 * frontend badges. Never inline this status list again.
 */
export const NON_TERMINAL_ENROLLMENT_STATUSES = [
    EnrollmentStatus.PENDING,
    EnrollmentStatus.ACTIVE,
    EnrollmentStatus.PAUSED,
];
export var EnrollmentWorkflowType;
(function (EnrollmentWorkflowType) {
    EnrollmentWorkflowType["EXISTING_SCHEDULES"] = "EXISTING";
    EnrollmentWorkflowType["INLINE_SCHEDULE_CREATION"] = "INLINE";
})(EnrollmentWorkflowType || (EnrollmentWorkflowType = {}));
//# sourceMappingURL=Enrollment.js.map